/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// Utilities for rounding lot sizes according to broker step constraints

function stepDecimals(step) {
  if (!step || typeof step !== 'number') return 2;
  // Handle scientific notation e.g., 1e-2
  const s = step.toString();
  if (s.includes('e-')) {
    const [, exp] = s.split('e-');
    const d = parseInt(exp, 10);
    return Number.isFinite(d) ? d : 2;
  }
  const parts = s.split('.');
  return parts[1] ? parts[1].length : 0;
}

function clamp(val, min, max) {
  let v = val;
  if (typeof min === 'number') v = Math.max(min, v);
  if (typeof max === 'number') v = Math.min(max, v);
  return v;
}

export function roundToStepNumber(value, step = 0.01, mode = 'down', min, max) {
  const v = Number(value);
  const st = Number(step) || 0.01;
  if (!Number.isFinite(v) || !Number.isFinite(st) || st <= 0) return 0;
  const units = v / st;
  let roundedUnits;
  switch (mode) {
    case 'up':
      roundedUnits = Math.ceil(units);
      break;
    case 'nearest':
      roundedUnits = Math.round(units);
      break;
    case 'down':
    default:
      roundedUnits = Math.floor(units);
  }
  const result = roundedUnits * st;
  return clamp(result, min, max);
}

export function roundToStepString(value, step = 0.01, mode = 'down', min, max) {
  const num = roundToStepNumber(value, step, mode, min, max);
  const decimals = stepDecimals(step);
  return num.toFixed(decimals);
}

export function getStepBoundsFromSymbolInfo(info) {
  if (!info || typeof info !== 'object') return { step: 0.01, min: 0.01, max: undefined };
  const step = info.lot_step ?? info.volume_step ?? 0.01;
  const min = info.min_lot ?? info.min_volume ?? 0.01;
  const max = info.max_lot ?? info.max_volume ?? undefined;
  return { step: Number(step) || 0.01, min: Number(min) || 0.01, max: typeof max === 'number' ? max : undefined };
}

export function stepDecimalsCount(step) {
  return stepDecimals(step);
}
